import { Card } from "@rothoblaas/design-system";
import type { ReactNode } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import styles from "../../LockCalculator.module.css";
import { CombinedVerificationForm } from "./CombinedVerificationForm";
import { LoadsForm } from "./LoadsForm";

type Props = { readOnly: boolean; onOpenHelp: (text: string, image?: string) => void; stepper: ReactNode };

export const LoadsStep = ({ readOnly, onOpenHelp, stepper }: Props) => {
  const { translation: t } = useI18n();
  return (
    <>
      <Card style={{ minHeight: 400 }}
        accentColor="var(--accent-base, var(--red))"
        shadow
        className={styles.stepCard}
      >
        {stepper}
        <Card.Title>{t.lockCalculatorModule.loads.sectionTitle}</Card.Title>
        <div className={styles.compactFormStack}>
          <LoadsForm readOnly={readOnly} onOpenHelp={onOpenHelp} />
          <CombinedVerificationForm readOnly={readOnly} onOpenHelp={onOpenHelp} />
        </div>
        {/* </Card> */}
      </Card>
    </>
  );
};
